import { action, makeObservable, observable, runInAction } from 'mobx';
import { createContext, useContext } from 'react';
import { bpHistory } from 'global/bpHistory';

import { CensusEnrollmentModule } from 'store/modules/census/enrollment-based/censusEnrollmentModule';
import ICensusUploadPageStore from 'store/modules/census/iCensusUploadPageStore';

interface DomainProps {
  groupId: string;
  enrollmentPeriodId: string;
}

export default class ManageAddEmployeesCensusPageStore extends ICensusUploadPageStore<
  DomainProps,
  CensusEnrollmentModule
> {
  protected _censusModule: CensusEnrollmentModule;
  protected _domainData: DomainProps;

  public async getCensusData(): Promise<void> {
    this.setIsLoading(true);
    await runInAction(async () => {
      await Promise.all([
        this._censusModule.getRateSegmentData(),
        this._censusModule.getPreviouslyUploadedFiles(),
        this._censusModule.uploadExistingCensus(),
      ]);
    });
    this.setIsLoading(false);
  }

  public onCompleteRedirect(): void {
    bpHistory.push(
      `/manage-add-employees/census-review/${this._domainData.groupId}/${this._domainData.enrollmentPeriodId}`,
    );
  }

  constructor(domainData: DomainProps) {
    super();
    this._censusModule = new CensusEnrollmentModule({
      groupId: domainData.groupId,
      enrollmentPeriodId: domainData.enrollmentPeriodId,
    });
    this._domainData = domainData;

    makeObservable<ManageAddEmployeesCensusPageStore, '_censusModule' | '_domainData'>(this, {
      _censusModule: observable,
      _domainData: observable,

      getCensusData: action.bound,
      onCompleteRedirect: action.bound,
    });
  }
}

const ManageAddEmployeesCensusPageStoreContext = createContext(
  new ManageAddEmployeesCensusPageStore({} as DomainProps),
);

export const useManageAddEmployeesCensusPageStoreContext = (): ManageAddEmployeesCensusPageStore => {
  return useContext(ManageAddEmployeesCensusPageStoreContext);
};

export { ManageAddEmployeesCensusPageStoreContext };
